'use client';

import { useMemo } from 'react';

import { SectionLayout } from 'components';
import NotificationsGroup from './components/NotificationsGroup';

import { groupByPriority } from './utils/group';
import useInternalNotifications from './hooks/useInternalNotifications';

import { IInternalNotificationsProps } from './InternalNotifications.types';

import './InternalNotifications.styles.scss';

const InternalNotifications = ({ disabledTypes = [], className = '', ...props }: IInternalNotificationsProps) => {
  const { notifications, onDelete } = useInternalNotifications(disabledTypes);

  const isEmpty = !notifications || !notifications.length;

  const groupedNotifications = useMemo(() => groupByPriority(notifications), [notifications]);

  return (
    !isEmpty && (
      <SectionLayout noPaddingsY>
        <div className={`np-internal-notifications ${className}`} {...props}>
          {groupedNotifications
            .map(notifications => <NotificationsGroup key={Math.random()} data={notifications} onDelete={onDelete} />)
            .filter(Boolean)}
        </div>
      </SectionLayout>
    )
  );
};

export default InternalNotifications;
